module.exports = __webpack_public_path__ + "static/media/sale-icon-over.606b02a5.svg";